<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createAvailableDate" (change)="createAvailableDateChange()" (submit)="createAvailableDateSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"CREATE_AVAILABLE_DATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/attendence/available-dates"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="text-bold">{{ "DATE" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="date">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAvailableDate.controls.date.touched && createAvailableDate.controls.date.invalid && createAvailableDate.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="text-bold">{{ "START_DATE" | translate | titlecase }}</label>
                                <input type="datetime-local" class="form-control" formControlName="datetimeFrom">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAvailableDate.controls.datetimeFrom.touched && createAvailableDate.controls.datetimeFrom.invalid && createAvailableDate.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="text-bold">{{ "END_DATE" | translate | titlecase }}</label>
                                <input type="datetime-local" class="form-control" formControlName="datetimeTo">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAvailableDate.controls.datetimeTo.touched && createAvailableDate.controls.datetimeTo.invalid && createAvailableDate.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "STATUS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="status"
                                    >
                                    <option value="">{{ "SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{ "YES" | translate | titlecase }}</option>
                                    <option value="NO">{{ "NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAvailableDate.controls.status.touched && createAvailableDate.controls.status.invalid && createAvailableDate.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "GROUP" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="group"
                                    >
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of groups" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.egroupNameAr : field?.egroupNameEn
                                    }}- ({{field?.egroupCode}})
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAvailableDate.controls.group.touched && createAvailableDate.controls.group.invalid && createAvailableDate.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "SUBJECT" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="course"
                                    >
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of courses" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.subjectNameAr : field?.subjectNameEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAvailableDate.controls.course.touched && createAvailableDate.controls.course.invalid && createAvailableDate.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="text-bold">{{ "REMARKS" | translate | titlecase }}</label>
                                <textarea class="form-control" formControlName="remarks"></textarea>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="(createAvailableDate.controls.remarks.touched && createAvailableDate.controls.remarks.invalid && createAvailableDate.dirty)">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            
                            
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>